<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
        <div class="w-full h-full">
            <div class="w-full flex flex-col lg:flex-row justify-between items-start lg:items-center mb-3 lg:mb-5 gap-2 lg:gap-3">
                <div class="flex flex-row items-center justify-center gap-3">
                    <img src="@/assets/images/papsi_back_primary_icon.svg" class="w-8 h-8 cursor-pointer hover:bg-gray-200 rounded-full p-1" @click="goBack()">
                    <h1 class="text-theme-primary text-xl lg:text-3xl font-semibold">{{ this.$store.state.transaction_label }}</h1>
                    <div class="p-2 rounded-full bg-white hover:bg-gray-50 cursor-pointer" @click="refreshTransactions">
                        <img src="@/assets/images/papsi_refetch.svg" alt="">
                    </div>
                </div>
                <p class="italic text-gray-400 mt-0 lg:mt-2 text-xs lg:text-sm">Last Retrieved: {{ this.$store.state.last_sync }}</p>
            </div>

           <div class="w-full grid grid-cols-1 lg:grid-cols-5 gap-2 lg:gap-4 mb-5 ">
                <div class="rounded-lg bg-theme-primary text-white cols-span-1 lg:col-span-2 p-3 lg:p-5 font-light flex flex-col gap-1 relative">
                    <p>Current Balance</p>
                    <p class="text-2xl lg:text-4xl font-medium"><span class="flex flex-row"><PesoSignView /> {{ displayAmount(this.$store.state.transaction_balance) }}</span></p>
                    <p class="italic opacity-80">as of {{ this.$store.state.transaction_date }}</p>

                    <span class="cursor-pointer absolute" style="top: 10%; right: 3%" @click.stop="toggleMask">
                        <img
                            :src="isMasked
                                ? require('@/assets/images/papsi_password_invisible_white.svg')
                                : require('@/assets/images/papsi_password_visible_white.svg')"
                            class="w-4 h-4 lg:w-6 lg:h-6"
                        />
                    </span>
                </div>

                <div class="rounded-lg bg-white text-gray-500 cols-span-1 lg:col-span-3 p-3 lg:p-5 border-l-8 lg:border-l-[15px] border-theme-secondary flex flex-col items-start justify-center leading-8">
                    <p class="font-bold">What is {{ this.$store.state.transaction_label }}?</p>
                    <p class="text-xs lg:text-base">{{ transactionDescription }}</p>
                </div>
           </div>

           <div class="rounded-lg bg-white p-3 lg:p-5">
                <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-3">
                    <div class="flex flex-row items-center justify-center gap-2 lg:gap-4">
                        <p class="font-medium text-lg lg:text-xl">Transaction History</p>
                        <!-- <div class="flex flex-row items-center rounded-full bg-gray-300 overflow-hidden shadow">
                            <p @click="active_tab = 'ALL'" class="px-8 py-2 cursor-pointer" :class="[active_tab == 'ALL' ? 'bg-gray-100' : '']">All</p>
                            <p @click="active_tab = 'SUMMARY'" class="px-3 py-2 cursor-pointer" :class="[active_tab == 'SUMMARY' ? 'bg-gray-100' : '']">Summary</p>
                        </div> -->
                    </div>
                    <div class="flex flex-row items-center rounded-full bg-gray-200 overflow-hidden">
                            <p @click="active_tab = 'ALL'" class="px-5 lg:px-8 py-2 cursor-pointer" :class="[active_tab == 'ALL' ? 'bg-primary text-white' : '']">All</p>
                            <p @click="active_tab = 'SUMMARY'" class="px-3 py-2 cursor-pointer" :class="[active_tab == 'SUMMARY' ? 'bg-primary text-white' : '']">Summary</p>
                    </div>
                    <!-- <div class="flex flex-row items-center justify-center gap-3 lg:gap-6 text-xs lg:text-sm">
                        <div class="flex flex-row items-center justify-center gap-1">
                            <span class="bg-theme-primary w-2 h-2 rounded-full"></span>
                            <p class="font-medium text-theme-primary">Debit</p>
                        </div>

                        <div class="flex flex-row items-center justify-center gap-1">
                            <span class="bg-error w-2 h-2 rounded-full"></span>
                            <p class="font-medium text-error">Credit</p>
                        </div>
                    </div> -->
                </div>

                <p class="italic text-gray-400 mt-5 lg:mt-0 text-xs lg:text-sm">Note: If you have any concerns regarding your transaction history, please visit your nearest branch for assistance.</p>

                <div class="mt-5">
                    <DataTableControl
                        :columns="transactionColumns"
                        :rows="currentTransactionRows"
                        @row-click="handleRowClick"
                        rowKey="id"
                        height="50vh"
                        emptyText="No transactions found"
                    >
                    </DataTableControl>
                    <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-2 ">
                        <p class="mt-3">Want to see more? <span class="text-theme-primary hover:underline cursor-pointer font-medium" @click="showAllTransactions = !showAllTransactions">{{ showAllTransactions ? 'Show recent transactions' : 'View more transactions' }}</span></p>
                        <div v-if="active_tab == 'SUMMARY'" class="flex flex-row items-center justify-center gap-2">
                                <input type="checkbox"
                                    id="chkHideZero"
                                    class="form-checkbox h-3 w-3 text-primary cursor-pointer" style="accent-color: #016b00;"
                                    v-model="hideZeroBalances">
                                <p>Hide Zero Balances</p>
                        </div>
                    </div>
                </div>




           </div>

            <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
                :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
                @positiveClick="handlePositiveClick()" :positiveButton="'OK'" :default_width="'max-w-xl'"
                id='message_modal'>
                <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
                    {{ this.modal_message }}
                </div>
            </ModalControl>

            <ModalControl v-show="sub_ledger" v-bind:display="sub_ledger" z_value="z-50" @closed="sub_ledger = false" closable
                 :default_width="'max-w-[95%] lg:max-w-[70%]'" id='subledger_modal'>
                <div class="pt-[3%] w-full flex flex-col justify-start items-start">
                    <h1 class="text-theme-primary text-lg lg:text-3xl font-semibold flex flex-row items-center justify-center gap-2">{{this.$store.state.transaction_label}} 
                        <span
                            v-if="tracking"
                            class="text-white rounded-full px-2 lg:px-3 py-1 text-xs lg:text-base"
                            :class="isTrackingComplete ? 'bg-primary' : 'bg-red-500'"
                        >
                            {{ tracking }}
                        </span>
                    </h1>
        
                    <div class="w-full flex flex-col lg:flex-row items-start lg:items-center lg:justify-between text-gray-500 mt-2 text-sm lg:text-lg">
                        <p><span class="font-semibold">Loan ID:</span> {{ loan_id }}</p>
                        <p><span class="font-semibold">Balance:</span> {{ balance }}</p>
                    </div>
                    
                   
                    <DataTableControl
                            :columns="subLedgerColumns"
                            :rows="sub_ledger_rows"
                            rowKey="id"
                            class="mt-4"
                            emptyText="No transactions found"
                    />

    
                    
                    

                </div>
            </ModalControl>

        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import DataTableControl from '@/components/controls/DataTableControl.vue';
import PesoSignView from '../static/PesoSignView.vue';
import User from "@/services/User";
import mixin from '@/mixin';

export default defineComponent({
    components: {
        ModalControl,
        DataTableControl,
        PesoSignView
        // SkeletonControl
    },
    mixins: [mixin],
    inject: ['setLoading'],
    mounted() {
        let that = this;
        const state = that.$store.state;

        if (!state.credentials.username) {
            that.getUserInfo();
        } else {
            that.checkUserFlow();
        }

         this.buildServiceCards();
    },
    data() {
        return {
            isMasked: true,
            items: [],
            active_tab: 'ALL',
            sub_ledger: false,
            loan_id: '',
            balance: '',
            tracking: '',
            sub_ledger_rows: [],
            show_message_modal: false,
            modal_message: '',
            success: false,
            warning: false,
            error: false,
            question: false,
            expired: false,
            hideZeroBalances: false,
            showTransactionModal: false,
            transactionLoading: false,
            showAllTransactions: false,
            date_today: new Date().toLocaleDateString('en-US', {
                month: 'long',
                day: '2-digit',
                year: 'numeric',
            }), 
        }
    },
    computed: {
        isTrackingComplete() {
            if (!this.tracking) return false;

            const parts = this.tracking.split('of').map(value => parseInt(value.trim(), 10));

            if (parts.length !== 2) return false;

            return parts[0] === parts[1];
        },
        transactionColumns() {
            if (this.active_tab === 'SUMMARY') {
                return [
                    { field: 'date', label: 'Date', align: 'center' },
                    { field: 'loan_id', label: 'Loan ID', align: 'center' },
                    { field: 'tracking', label: 'Tracking', align: 'center' },
                    { field: 'amount', label: 'Gross Amount', align: 'right' },
                    { field: 'balance', label: 'Loan Balance', align: 'right' },
                ];
            }

            return [
                { field: 'date', label: 'Date', align: 'center' },
                { field: 'loan_id', label: 'Loan ID', align: 'center' },
                { field: 'description', label: 'Description', align: 'left' },
                { field: 'debit', label: 'Debit', align: 'right' },
                { field: 'credit', label: 'Credit', align: 'right' },
                { field: 'balance', label: 'Balance', align: 'right' },
            ];
        },
        transactionDataFromStore() {
            return this.$store.state.transaction_data || [];
        },
        transactionDescription() {
            const lookup = {
                SAV: 'Regular Savings Deposit refers to a primary deposit account offered by PAFCPIC that allows member to deposit money, earn interest, and withdraw funds when needed.',
                SSD: 'Special Savings Deposit refers to a type of deposit account offered by PAFCPIC to its member with special term and condition, that allows member to deposit money, earn interest, and withdraw funds upon maturity.',
                SHR: 'Share Capital (SC) is the amount a member contributes to the cooperative as part-owner and is used to sustain the cooperative’s operations.',
                D06: 'Salary Loan covers medium to large expenses intended for house repairs and other financial needs.',
                D07: 'Emergency Loan provides immediate financial assistance during urgent or unexpected situations requiring quick access to funds.',
                D09: 'This provides immediate loan assistance to members affected by calamities.',
                D14: 'This covers procurement of durable items such as but not limited to furniture, appliances, and other equipment. ',
                D18: 'This is intended to support the education needs of members or their dependents.',
                D19: 'This is intended for the acquisition of house and lot, condominium units, and other real estate properties or for house repair/renovation of an existing unit. ',
                D30: 'This covers capital and other expenses related to livelihood or income-generating projects.',
                D36: 'Petty Cash Loan covers small expenses and bills.',
                D44: 'Back-to-back loan uses a member’s Regular Savings Deposit (RSD), Time Deposit (TD), and/or Share Capital (SC) as collateral. ',
                D50: 'This is intended to help members cover transportation and commuting-related expenses, providing convenient financial support for daily travel needs.',
                D52: 'Multi-Purpose Loan is a flexible loan product that can be used for personal, educational, medical, or other financial needs.',
                D53: 'This is intended for the acquisition of new and pre-owned vehicles for personal or commercial/business use.',
                D54: 'This is intended for travel and leisure expenses, education-related expenses, minor house repairs, utility bills, and others. ',
            };

            return lookup[this.$store.state.transaction_key] || 
                'This account allows you to monitor your balances and transaction history.';
        },
        selectedTransactionLabel() {
            return this.$store.state.transaction_label || '';
        },
        filteredTransactionData() {
            const reversedRows = [...this.transactionDataFromStore].reverse();

            return this.showAllTransactions
                ? reversedRows
                : reversedRows.slice(0, 10);
        },
        formattedTransactionData() {
            return this.filteredTransactionData.map((row) => {

                return {
                    ...row,
                    credit: this.formatAmount(row.credit),
                    debit: this.formatAmount(row.debit),
                    loan_id: row.loan_id || row.loanId || '',
                    balance: this.formatAmount(row.balance),
                    date: this.formatDate(row.date),
                };
            });
        },
        summaryTransactionData() {
            const groups = {};

            (this.transactionDataFromStore || []).forEach((row) => {
                const loanId = row.loan_id || row.loanId || 'Unknown';

                if (!groups[loanId]) {
                    groups[loanId] = {
                        id: loanId,
                        loan_id: loanId,

                        amount: parseFloat(row.debit || 0), // Gross Amount = original loan release
                        balance: 0,                         // computed later
                        runningBalance: 0,

                        date: row.date,

                        term: row.term || '',
                        totalCredit: parseFloat(row.credit || 0),
                        count: 1,
                    };
                } else {
                    groups[loanId].count++;

                    groups[loanId].totalCredit += parseFloat(row.credit || 0);

                    const rowDate = row.date ? new Date(row.date) : null;
                    const currentDate = groups[loanId].date
                        ? new Date(groups[loanId].date)
                        : null;

                    if (rowDate && (!currentDate || rowDate > currentDate)) {
                        groups[loanId].date = row.date;
                    }
                }
            });

            Object.keys(groups).forEach((loanId) => {
                const transactions = (this.transactionDataFromStore || [])
                    .filter(r => (r.loan_id || r.loanId || 'Unknown') === loanId)
                    .sort((a, b) => new Date(a.date) - new Date(b.date));

                let runningBalance = 0;

                transactions.forEach((t) => {
                    runningBalance +=
                        parseFloat(t.debit || 0) -
                        parseFloat(t.credit || 0);
                });

                // Prevent "-0.00"
                groups[loanId].balance =
                    Object.is(runningBalance, -0) || Math.abs(runningBalance) < 0.000001
                        ? 0
                        : runningBalance;
            });

            let summaryRows = Object.values(groups)
                .filter((group) => {
                    // Existing Hide Zero Balances logic
                    if (this.hideZeroBalances && parseFloat(group.balance) === 0) {
                        return false;
                    }

                    return true;
                });


        summaryRows = summaryRows
            .map((group) => {

                const term = group.term || '';

                let trackingDisplay = '';

                // Check first if term starts with "O0"
                if (term.startsWith('O0')) {
                    const grossAmount = parseFloat(group.amount || 0);
                    const loanBalance = parseFloat(group.balance || 0);

                    trackingDisplay =
                        Math.abs(loanBalance) < 0.000001
                            ? '1 of 1'
                            : '0 of 1';
                } else {
                    const termNumber = parseInt(term.substring(1), 10) || 0;

                    const monthlyAmortization =
                        termNumber > 0
                            ? parseFloat(group.amount || 0) / termNumber
                            : 0;

                    const tracking =
                        monthlyAmortization > 0
                            ? Math.round(group.totalCredit / monthlyAmortization)
                            : 0;

                    trackingDisplay = `${tracking} of ${termNumber}`;
                }

                return {
                    ...group,
                    amount: this.formatAmount(group.amount),
                    balance: this.formatAmount(group.balance),
                    tracking: trackingDisplay,
                    date: this.formatDate(group.date),
                };
            })
            .filter(group => group.tracking !== '0 of 0')
            .sort((a, b) => {
                if (a.loan_id < b.loan_id) return 1;
                if (a.loan_id > b.loan_id) return -1;
                return 0;
            });

            return summaryRows;
        },
        currentTransactionRows() {
            return this.active_tab === 'SUMMARY' ? this.summaryTransactionData : this.formattedTransactionData;
        },
        subLedgerColumns() {
            return [
                { field: 'date', label: 'Date', align: 'center' },
                { field: 'loan_id', label: 'Loan ID', align: 'center' },
                { field: 'description', label: 'Description', align: 'left' },
                { field: 'debit', label: 'Debit', align: 'right' },
                { field: 'credit', label: 'Credit', align: 'right' },
                { field: 'balance', label: 'Balance', align: 'right' },
            ];
        }
    },
    methods: {
        formatLastSync(datetime) {
            if (!datetime) {
                return 'N/A';
            }

            // Convert "2026-07-31 16:26:28" to a format Date can reliably parse
            const date = new Date(datetime.replace(' ', 'T'));

            return date.toLocaleString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            });
        },
        toggleMask() {
            this.isMasked = !this.isMasked;
        },

        displayAmount(amount) {
            return this.isMasked
                ? '*****'
                : this.formatAmount(amount);
        },
        refreshTransactions() {
            const state = this.$store.state;
            const type = state.transaction_key || 'D06';

            if (!state.credentials.hash || !state.credentials.uuid) {
                this.error = true;
                this.show_message_modal = true;
                this.modal_message = 'Session information not available';
                return;
            }

            this.setLoading(true);
            User.fetchTransaction(
                state.credentials.hash,
                type,
                state.credentials.uuid,
                state.credentials.key
            ).then((response) => {
                const transactions = (response.data.data || []).map((transaction, index) => ({
                    id: index,
                    ...transaction,
                }));
                const lastTransaction = transactions.length
                    ? transactions[transactions.length - 1]
                    : null;
                console.log('Last Transaction:', lastTransaction);
                console.log('All Transactions:', transactions);
                const latestBalance = lastTransaction?.balance ?? state.transaction_balance;
                const latestDate = lastTransaction?.date;

                state.balances[type] = {
                    ...state.balances[type],
                    total_balance: latestBalance,
                    as_of: latestDate || state.balances?.[type]?.as_of,
                };
                state.transaction_balance = latestBalance;
                state.transaction_date = latestDate
                    ? new Date(latestDate).toLocaleDateString('en-US', {
                        month: 'long',
                        day: '2-digit',
                        year: 'numeric',
                    })
                    : state.transaction_date;

                state.transaction_cache[type] = {
                    ...(state.transaction_cache[type] || {}),
                    data: transactions,
                    label: state.transaction_label,
                    balance: state.transaction_balance,
                    date: state.transaction_date,
                };
                state.transaction_data = transactions;
                state.last_sync = this.formatLastSync(response.data.timestamp);
            }).catch((error) => {
                this.error = true;
                this.show_message_modal = true;
                this.modal_message = error.response?.data?.message || 'Failed to fetch transactions';
                if (error.response.status == 403) {
                    this.expired = true
                    this.modal_message = "Your session has expired. Please log in again.";
                    this.$store.state.logged = false;
                }
            }).finally(() => {
                this.setLoading(false);
            });
        },
        goBack() {
            this.$router.push('/balance-inquiry');
        },
        formatDate(date) {
            if (!date) return '';

            const [year, month, day] = date.split('-');

            return `${month}/${day}/${year}`;
        },
        isWithinLast6Months(dateStr) {
            if (!dateStr) return false;

            const date = new Date(dateStr);
            const now = new Date();

            const sixMonthsAgo = new Date();
            sixMonthsAgo.setMonth(now.getMonth() - 6);

            return date >= sixMonthsAgo && date <= now;
        },
        closed() {
            let that = this;

            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        buildServiceCards() {
            this.items = [
                {
                    image: require('@/assets/images/papsi_eft.png'),
                    title: "Savings",
                    subtitle: "Receive your Patronage Refund directly to your Bank Account for FREE!",
                    open: () => this.$router.push('/services/EFT'),
                    deployed: true,
                },
                {
                    image: require('@/assets/images/papsi_calculator.png'),
                    title: "Share Capital",
                    subtitle: "Estimate your loan repayment quickly and easily.",
                    open: () => this.$router.push('/services/calculator'),
                    deployed: true,
                },
                {
                    image: require('@/assets/images/papsi_ledger.png'),
                    title: "Loans",
                    // subtitle: "View your current balance and account details anytime.",
                    open: () => this.$router.push('/services/balance-inquiry'),
                    deployed: true,
                },
            ];
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.gaUser = data.ga;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                state.balances = data.balances;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            // this.show_loader = true;
            // this.buildServiceCards();

            if (this.transactionDataFromStore.length == 0) {
                this.$router.back();
                return;
            }


            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
        toTitleCase(str) {
            return str
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase());
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.show_message_modal = false;
                this.show_pin_modal = false;
                this.pin_value = '';
            }
        },
        handleRowClick(row) {
            if (this.active_tab === 'SUMMARY') {
                this.openSubLedger(row);
            }
        },
        openSubLedger(row) {
            const loanId = row.loan_id || row.loanId || row.id || '';

            this.loan_id = loanId;
            this.tracking = row.tracking || '';

            const matches = [...(this.transactionDataFromStore || [])]
                .filter(r => {
                    const rid = r.loan_id || r.loanId || '';
                    return String(rid) === String(loanId);
                })
                .reverse();

            // Clone the rows first
            const rows = matches.map(r => ({
                ...r,
                credit: this.formatAmount(r.credit),
                debit: this.formatAmount(r.debit),
                loan_id: r.loan_id || r.loanId || '',
                date: this.formatDate(r.date),
            }));

            
            // Compute from the bottom of the table
            let runningBalance = 0;

            for (let i = rows.length - 1; i >= 0; i--) {
                runningBalance +=
                    parseFloat(matches[i].debit || 0) -
                    parseFloat(matches[i].credit || 0);

                // Prevent displaying "-0.00"
                const normalizedBalance = Object.is(runningBalance, -0) || Math.abs(runningBalance) < 0.000001
                    ? 0
                    : runningBalance;

                rows[i].balance = this.formatAmount(normalizedBalance);
            }

            this.sub_ledger_rows = rows;

            // The loan balance shown above the table
            const finalBalance = rows.length
                ? (Object.is(runningBalance, -0) || Math.abs(runningBalance) < 0.000001
                    ? 0
                    : runningBalance)
                : 0;

            this.balance = this.formatAmount(finalBalance);

            this.sub_ledger = true;
        }
    },
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
